import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({}))

export default useStyles
